import axios from 'axios';
import {
  RUNNING_TYPE,
  RUNNING_TYPE_MASTER,
  RUNNING_TYPE_DEVELOP,
  RUNNING_TYPE_LOCAL,
  DELETE_LOG_API_URL,
  DELETE_LOG_API_DEV_URL,
  DELETE_LOG_API_LOCAL_URL,
  API_KEY,
  API_KEY_RC_TEST,
} from '../util/Const';

/**
 * 履歴削除APIリクエストIF
 */
export type SendRequestDto = {
  id: any;
};

// 履歴削除API
export const PostDeleteLog = async (dto: SendRequestDto) => {
  let url: string;
  let apiKey: string;
  switch (RUNNING_TYPE) {
    case RUNNING_TYPE_MASTER:
      url = DELETE_LOG_API_URL;
      apiKey = API_KEY;
      break;
    case RUNNING_TYPE_DEVELOP:
      url = DELETE_LOG_API_DEV_URL;
      apiKey = API_KEY_RC_TEST;
      break;
    case RUNNING_TYPE_LOCAL:
      url = DELETE_LOG_API_LOCAL_URL;
      apiKey = API_KEY_RC_TEST;
      break;
    default:
      url = '';
      apiKey = '';
      break;
  }

  if (
    RUNNING_TYPE === RUNNING_TYPE_MASTER ||
    RUNNING_TYPE === RUNNING_TYPE_DEVELOP ||
    RUNNING_TYPE === RUNNING_TYPE_LOCAL
  ) {
    const res = await axios
      .post(url, JSON.stringify(dto), {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': apiKey,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
    return res;
  }
  const res = await axios
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
  console.info(JSON.stringify(dto));
  return res;
};

export default PostDeleteLog;
